module.exports = __webpack_public_path__ + "fonts/intelo-semibold.213848e.woff";